import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const landmarkGlobalSettings = defineIntegrationSettings({
  fields: {
    username: z.string().trim().min(1, "Username is required"),
    shippingLaneRegion: z
      .string()
      .trim()
      .min(1, "Shipping lane region is required"),
    clientId: z.string().trim().min(1, "Client ID is required"),
  },
  secrets: { password: z.string().trim().min(1, "Password is required") },
  connectOnly: {},
  computed: {},
});
